import React__default from 'react';
import { Box, Typography } from '@vp/swan';
import '../../../../../../../lodash.clonedeep/index.mjs';
import '../../product-option/context/product-option-context.mjs';
import '../../product-option/context/validators/description-validator.mjs';
import '../../product-options-translations/product-option-translations.mjs';
import { useProductOptionContext } from '../../product-option/context/use-product-option-context.mjs';
import { SimpleTitleText } from './simple-title-text.mjs';

const SimpleTitle = ({ titleId, showSelectedOptionText }) => {
    const { productOption } = useProductOptionContext();
    return (React__default.createElement(Box, { mb: "2" },
        React__default.createElement(Typography, { id: titleId, fontSkin: "body-standard-bold", "aria-required": productOption.isRequired ? "true" : undefined, as: "label" },
            React__default.createElement(SimpleTitleText, { showSelectedOptionText: showSelectedOptionText }))));
};

export { SimpleTitle };
//# sourceMappingURL=simple-title.mjs.map
